import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectIsModal } from '../../../../../selectors/layout';
import { Wrapper } from './Wrapper';
import { useDeviceType } from '@cian/ui-kit';

interface IProps {
  children: React.ReactNode;
}

export const WrapperContainer = (props: IProps) => {
  const { children } = props;

  const isModal = useSelector(selectIsModal);
  const deviceType = useDeviceType();

  const isPhone = deviceType === 'phone';

  return (
    <Wrapper isModal={isModal} isPhone={isPhone}>
      {children}
    </Wrapper>
  );
};
